var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 136,
    viewBox: "0 0 354 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2682 16.264H88.8894C94.8263 16.264 102.34 17.6835 102.34 27.781C102.34 37.8796 91.5958 41.9967 83.6267 41.9967H67.2682V16.264ZM67.2682 55.7187H79.5871C99.8323 55.7187 110.15 60.1498 110.15 72.0169C110.15 82.5352 101.873 86.9819 88.8933 86.9819H69.1816L46.64 102.793V102.794L88.7394 102.784C113.951 102.784 130.925 93.6915 130.925 72.6515C130.925 54.2992 115.902 47.0914 102.496 47.0914C111.761 47.0914 122.708 38.7753 122.708 24.6731C122.708 10.5737 109.834 0.450073 95.1564 0.450073L52.1857 0.451186H42.8672L46.64 8.83189V95.43L67.2682 80.9593V55.7187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.756 16.2629H178.807C184.605 16.2629 214.17 17.7319 214.17 51.6216C214.17 90.2897 178.807 86.9736 178.807 86.9736L166.674 86.9786L144.126 102.79V102.793H184.605C209.815 102.793 235.663 87.2614 235.663 51.6216C235.663 20.0232 213.093 0.450073 184.605 0.450073H140.355L144.126 8.83077V95.425L164.756 80.9582V16.2629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.597 51.6477C266.597 22.7097 286.501 14.5795 299.396 14.5795C312.289 14.5795 332.193 22.7097 332.193 51.6477C332.193 80.588 312.289 88.7159 299.396 88.7159C286.501 88.7159 266.597 80.588 266.597 51.6477ZM245.104 51.6477C245.104 92.4807 278.048 103.951 299.396 103.951C320.738 103.951 353.686 92.4807 353.686 51.6477C353.686 10.8158 320.738 -0.655518 299.396 -0.655518C278.048 -0.655518 245.104 10.8158 245.104 51.6477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.450073V128.027L20.1502 113.891V0.450073H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8302 119.276L-0.0928633 136.052L352.498 135.956L352.503 119.187L23.8302 119.276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.a525d65ffe874b2cd33543c4823287dc.svg";
export { ForwardRef as ReactComponent };